var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2929_916",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2929_916",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC10lEQVR4nO2dy04UQRSGjySuIL4EU0XCAlET0TcQ4yVRl6y7KpP4DGy8rBF9AcIzibrAxOADeFnohjbVwwJ6YDR29czP1PcltT1dc77UqZqcxTEDAAAAAAC4DNyqrtpKeGYu7puLB+biT/OxLnq58OMkF/s2iE+bHE0FHx6bi59mngAvvlKOVuKjHk1sL5gLr2f+Q/2lWsfm46smd9lBRv3/YsLL/GVqZPv0R36ZDzvmqg1b21q00lnbWmxy4eOuufh77KQMqod5PpQup/E748hcuJ7nA3OIG643OTpzp4SPeS769Jpqnwxk/J1BvDF2UtLrqzPpGXdWyE73oIXgwtvWKdnLEfRDK+jtHHstgkG803oKH3QPmv7wnA66OlzKsdciWB0utYR87x60/YSDGecPId1AiBgIEQMhYiBEDISIgRAxECIGQsRAiBgIEUNOiAv3zcXPAv3tutMa/YbNqecve0Afvsw8mT7bOpp6/rIHREgtJiRumouHc1CyDs1X96aev/4DFoZHiBYIEQMhYiBEDISIgRAxECIGQsRAiBgIEQMhYiBEDISIISeEjmGtJYQGVY0QTwt30gmjY+iVSlbpeLWSVToeIVogRAyEiIEQMRAiBkLEQIgYCBEDIWIgRAyEiIEQMeSE0DGstYTQMawR4ukYTjphdAy9UskqHa9WskrHI0QLhIiBEDEQIgZCxECIGAgRAyFiIEQMhMy7kDSE5HRABrr8O4Pn184KCd8s/8ijaqN70EJYru72MPKoPRQsvsmx1yJw8V3+oWDnjs0brufY71yzXN0cG5vnqic9DpZEymQZ4Ws/gyUTaepxe/TqyP5uUye56K3JQcpFKlPnjl6NDywraepxf73qeV8vLD/bCydSWkOKWXZxDo5PZFyx3kjlK9VDRNQTc5BylL1MXUS6nNKg3fSM8+H92DTQEpdLOWhysde8prJd4AAAAAAAANYrfwBfA0ScHgnQLwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.931fb43d8c8399f2e29174538117fc25.svg";
export { ForwardRef as ReactComponent };